/** Columnas del formato Excel de importación/exportación de clientes. */
export const COLUMNAS_IMPORT_CLIENTES = [
  'nroCliente',
  'nombre',
  'codigoDireccion',
  'razonSocial',
  'direccion',
  'codigoCiudad',
  'telefono1',
  'telefono2',
  'email',
  'cuit',
  'tipoIva',
  'condVta',
  'credito',
  'nroLista',
  'contacto',
  'fechaAlta',
  'fechaBaja',
  'tipoCliente',
  'ctaMaestra',
  'nroCuenta',
  'deposito',
  'nroClienteExterno',
  'vendedor',
  'codigoRuta',
  'porcDesc',
  'porcDesc2',
  'porcDesc3',
] as const;

export const CAMPOS_REQUERIDOS_IMPORT_CLIENTES = ['nroCliente', 'nombre', 'codigoCiudad'] as const;

export const CAMPOS_NUMERICOS_IMPORT_CLIENTES = [
  'nroCliente',
  'codigoCiudad',
  'credito',
  'ctaMaestra',
  'nroCuenta',
  'deposito',
  'vendedor',
  'codigoRuta',
  'porcDesc',
  'porcDesc2',
  'porcDesc3',
] as const;
